import React from "react";
import Subheader from "../components/Subheader";

const formatNumber = (num) =>
  typeof num === "number" ? num.toLocaleString("de-DE") : num;

const DeletingConfirmation = ({
  handleDelete,
  handleDeleteModal,
  count,
  description,
  showBlacklistOption = false,
  blacklistChecked = false,
  onBlacklistChange,
}) => {
  return (
    <div className="bg-background p-10 rounded-lg w-[300px] md:w-[500px] overflow-auto">
      <div className="bg-background mb-4 flex justify-between items-center">
        <div className="m-auto">
          <Subheader>
            Bist du dir <em>sicher ?</em>
          </Subheader>
        </div>
      </div>
      <section className="text-center">
        {typeof count === "number" && (
          <p className="text-textTitle text-2xl font-bold mb-3">
            <span className="text-red-500">{formatNumber(count)}</span>{" "}
            {count === 1 ? "ASIN" : "ASINs"} werden gelöscht
          </p>
        )}
        <p className="text-emptyText pb-2 leading-5 text-[16px]">
          {description ||
            "Hiermit bestätigst du die Löschung aller Asins, die du angelegt hast. Bitte beachte, dass du nur alle 7 Tage deine Asins verändern kannst."}
        </p>

        {showBlacklistOption && (
          <label className="inline-flex items-center gap-2 mt-4 cursor-pointer text-textTitle text-sm">
            <input
              type="checkbox"
              checked={blacklistChecked}
              onChange={(e) => onBlacklistChange && onBlacklistChange(e.target.checked)}
              className="w-4 h-4 cursor-pointer accent-primary"
            />
            Diese ASINs zusätzlich zur Blacklist hinzufügen
          </label>
        )}

        <div className="flex justify-center items-center gap-4 mt-6">
          <div className="rounded text-center dark:bg-delete-btn-dark bg-delete-btn-light">
            <button
              className="p_detail
                px-3 pt-2 pb-2 w-24 text-[12px] text-text border-none font-semibold tracking-widest  dark:text-[#FF5959]"
              onClick={handleDelete}
            >
              Löschen
            </button>
          </div>
          <div>
            <div className=" bg-deleteButton rounded text-center shadow">
              <button
                className="p_detail px-3 pt-2 pb-2 w-24 text-[12px] text-deleteBtnText border-none font-semibold tracking-widest"
                onClick={handleDeleteModal}
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeletingConfirmation;
